var u = function (t) {
  return t.default = "default", t.routing = "routing", t.button = "button", t;
}(u || {});
export { u as LinkKind };